<template>
  <div>
    <b-form-group>
      <label>Chiết khấu</label>
      <b-input-group>
        <template #append>
          <b-button
            size="sm"
            style="width: 40px"
            variant="secondary"
            @click="onChangeDiscountType"
          >
            <i
              v-if="selectDiscountType === 2"
              class="fa fa-percent"
              aria-hidden="true"
            ></i>
            <i v-else class="fas fa-dollar-sign" aria-hidden="true"></i>
          </b-button>
        </template>
        <template class="relative">
          <b-form-input
            size="sm"
            class="text-right"
            id="input-discount"
            v-model="orderDiscount.discountAmount"
            @change="onChangeDiscountAmount"
            :min="1"
            v-mask="mask"
            autocomplete="off"
          ></b-form-input>
          <label class="absolute text-primary">{{
            selectDiscountType === 2 ? 'Phần trăm' : 'Tiền mặt'
          }}</label>
        </template>
      </b-input-group>
    </b-form-group>
    <b-form-group :disabled="id ? true : false">
      <label>Mã coupon:</label>
      <b-input-group>
        <b-form-input
          class="input-style"
          size="sm"
          v-model="orderDiscount.couponCode"
          placeholder="Nhập mã coupon"
          @change="onChangeCouponCode()"
          autocomplete="off"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            style="width: 40px"
            @click="checkCoupon()"
            variant="secondary"
            size="sm"
          >
            <i class="fas fa-sync"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import jQuery from 'jquery';
import Swal from 'sweetalert2';

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle',
  },
});
import {
  currencyMask,
  makeToastFaile,
  makeToastSuccess,
  unMaskPrice,
} from '@/utils/common';
import { AMOUNT_TYPE, DISCOUNT_AMOUNT_TYPE } from '@/utils/enum';
import timeUtils from '@/utils/date';
import { mapGetters } from 'vuex';
import { SET_ORDER_DISCOUNT_INFO } from '@/core/services/store/modules/order/order-discount.module.js';
import { commonMixin } from '@/view/mixins/';
import { cloneDeep } from '../../../utils/common';

export default {
  props: {
    action: String,
  },
  mixins: [commonMixin],
  data() {
    return {
      orderDiscount: null,
      selectDiscountType: DISCOUNT_AMOUNT_TYPE.MONEY,
      stateCouponCode: null,
      selectTypeSearch: 1,
      listTypeSearch: [
        {
          id: 1,
          name: 'Tìm sản phẩm',
        },
        {
          id: 2,
          name: 'Tìm sản phẩm imei',
        },
      ],
      searchProduct: null,
      filteredOptionsProduct: [],
      mask: currencyMask,
      listOrderItem: [],
      id: null,
      dpConfigs: null,
      orderInfo: null,
      customerInfo: null,
      onLoading: false,
      showOtp: false,
      validCouponCode: null,
      subtractPointTerm: 0,
      historyDraft: [],
    };
  },
  watch: {
    orderDiscount: {
      handler: function (newValue) {
        this.$store.dispatch(SET_ORDER_DISCOUNT_INFO, newValue);
      },
      deep: true,
    },
  },
  created() {
    this.dpConfigs = timeUtils.DP_CONFIG;

    this.orderDiscount = this.getOrderDiscount;

    const discountType =
      this.getOrderDiscount.discountType || AMOUNT_TYPE.MONEY;
    this.selectDiscountType = discountType;

    this.orderInfo = this.getOrderInfo;
    this.customerInfo = this.getOrderCustomerInfo;
  },
  mounted() {},
  computed: {
    ...mapGetters([
      'getOrderDiscount',
      'getOrderInfo',
      'getOrderCustomerInfo',
      'getProducts',
    ]),
  },
  methods: {
    onChangeDiscountAmount: async function () {
      if (this.validCouponCode && this.orderDiscount.couponCode) {
        this.orderDiscount.couponCode = null;
        this.validCouponCode = false;
      }
    },
    onChangeDiscountType() {
      this.selectDiscountType =
        this.selectDiscountType === AMOUNT_TYPE.PERCENT
          ? AMOUNT_TYPE.MONEY
          : AMOUNT_TYPE.PERCENT;
      this.orderDiscount.discountType = this.selectDiscountType;
    },
    onChangeSubtractPoint: async function () {
      if (this.orderDiscount.subtractPointAmount) {
        const text = `Chỉnh sửa lại tiêu điểm sẽ xác nhận lại mã otp`;

        const alert = await this.showWarningPointAlert(text);
        if (alert.isConfirmed) {
          this.orderDiscount.otpCode = null;
          this.orderDiscount.subtractPointAmount = null;
          return;
        } else {
          this.orderDiscount.subtractPoint = this.subtractPointTerm;
        }
      }
    },
    onChangeCouponCode() {
      if (!this.orderDiscount.couponCode) {
        this.validCouponCode = null;
        this.orderDiscount.discountAmount = 0;
        this.orderDiscount.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
        return;
      }
      if (
        this.validCouponCode &&
        this.validCouponCode !== this.orderDiscount.couponCode
      ) {
        this.orderDiscount.discountAmount = 0;
        this.orderDiscount.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
        this.validCouponCode = null;
      }
    },
    checkCoupon: async function () {
      const products = this.getProducts;
      if (!products || !products.length) {
        makeToastFaile(`Vui lòng chọn sản phẩm`);
        return;
      }

      if (!this.orderDiscount.couponCode) {
        makeToastFaile(`Vui lòng nhập mã coupon`);
        return;
      }

      if (this.orderDiscount.discountAmount) {
        const text = `Sử dụng mã coupon ${this.orderDiscount.couponCode} thay cho chiết khấu`;

        const alert = await this.showWarningAlert(text);

        if (!alert.isConfirmed) {
          this.orderDiscount.couponCode = null;
          this.validCouponCode = null;
          return;
        }
      }

      // const productsFormatter = this.formatOrderItem(products);
      const data = {
        storeId: this.orderInfo.storeId,
        listProduct: this.handleOrderItemUpsert(cloneDeep(products)),
        couponCode: this.orderDiscount.couponCode,
      };

      ApiService.post('coupon/check-coupon', data)
        .then((response) => {
          const { data } = response.data;
          const { status, message } = response.data;

          if (status === 1) {
            makeToastSuccess(message);
            this.orderDiscount.discountAmount = data;
            this.orderDiscount.discountType = DISCOUNT_AMOUNT_TYPE.MONEY;
            this.validCouponCode = data;
          } else {
            makeToastFaile(message);
          }
        })
        .catch(({ response }) => {
          makeToastFaile(response.$error);
        });
    },
    checkCustomerPoint() {
      if (!this.onLoading) {
        const pointUse = unMaskPrice(this.orderDiscount.subtractPoint) || 0;

        this.orderDiscount.subtractPointAmount = null;
        this.orderDiscount.otpCode = null;
        const customerId = this.customerInfo.customerId || null;

        if (pointUse <= 0) {
          this.showOtp = false;
          makeToastFaile('Số điểm không hợp lệ');
          return;
        }
        this.onLoading = true;
        const data = {
          customerId: customerId,
          pointUse: pointUse,
          phoneNumber: this.customerInfo.customerMobile,
        };

        ApiService.post('customerOTP/', data)
          .then((response) => {
            this.onLoading = false;
            const { status, message } = response.data;
            if (status === 1) {
              makeToastSuccess(message);
              this.subtractPointTerm = pointUse;
              this.showOtp = true;
            } else {
              makeToastFaile(message);
            }
          })
          .catch(({ response }) => {
            this.onLoading = false;
            makeToastFaile(response.$error);
          });
      }
    },
    checkValidOTP() {
      if (!this.onLoading) {
        this.onLoading = true;

        const customerId = this.customerInfo.customerId;
        const data = {
          customerId: customerId,
          pointUse: unMaskPrice(this.orderDiscount.subtractPoint),
          otpCode: this.orderDiscount.otpCode,
        };

        ApiService.post('customerOTP/checkOTP', data)
          .then((response) => {
            this.onLoading = false;

            const { data } = response.data;
            const { status, message } = response.data;

            if (status === 1) {
              makeToastSuccess(message);
              this.orderDiscount.subtractPointAmount = data;
            } else {
              makeToastFaile(data.message);
            }
          })
          .catch(({ response }) => {
            this.onLoading = false;
            makeToastFaile(response.$error);
          });
      }
    },
    showWarningAlert: function (text) {
      return Swal.fire({
        title: 'Sử dụng chiết khấu!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    showWarningPointAlert: function (text) {
      return Swal.fire({
        title: 'Sử dụng điểm!',
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Đồng ý',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        showClass: {
          popup: 'animate__animated animate__fadeInDown',
        },
        hideClass: {
          popup: 'animate__animated animate__fadeOutUp',
        },
      });
    },
    onClickHandoverHistory() {
      this.histories = this.historyDraft;
    },
  },
};
</script>
<style scoped>
#history-table tbody tr td > span {
  display: block;
}
#history-table th,
td {
  padding: 0.3rem;
}
#history-table tbody tr td > b {
  width: max-content;
}
</style>
